export default {
  fromServer: () => ({}),
  toServer: data => ({
    name: data.name,
    content_type: data.contentType,
    folder: data.folder,
  }),
};
